/* eslint-disable */
import React from 'react';
import { AccordionDetails } from '@mui/material';
import { ReactComponent as ExpandMore } from 'assets/icons/arrow-down.svg';
import {
  AccordionCommonSummaryStyled,
  ExpandMoreIconStyled,
  LabelStyled,
  AccordionCommonStyled,
} from './AccordionCommonStyles';

const DS_AccordionCommonElementMUI = ({
  isOpenedByDefault = false,
  color,
  expandedAlways = false,
  headerContent,
  mainContent,
  expanded,
  onChange,
  ...otherProps
}) => {
  return (
    <AccordionCommonStyled
      sx={{ boxShadow: 0, position: 'inherit' }}
      defaultExpanded={isOpenedByDefault}
      expanded={expanded}
      data-test="accordion-wrapper"
      onChange={onChange}
      {...otherProps}
    >
      <AccordionCommonSummaryStyled
        data-test="accordion-summary"
        $expandedAlways={expandedAlways}
        expandIcon={<ExpandMoreIconStyled component={ExpandMore} inheritViewBox />}
      >
        <LabelStyled variant="DS_copyMediumBold" component="span" $expandedAlways={expandedAlways}>
          {headerContent ? headerContent : null}
        </LabelStyled>
      </AccordionCommonSummaryStyled>

      <AccordionDetails data-test="accordion-details">{mainContent ? mainContent : null}</AccordionDetails>
    </AccordionCommonStyled>
  );
};

export default DS_AccordionCommonElementMUI;
